module.exports = __webpack_public_path__ + "media/images/flags/1x1/sco-3222a87deb284d50a860a52ad438656e.svg";